module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lxts"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [(_vm.$route.params.nr === 'lxwm') ? _c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.nr === 'tsjy') ? _c('div', {
    staticClass: "title"
  }, [_vm._v("投诉建议")]) : _vm._e()])], 1), _vm._v(" "), (_vm.$route.params.nr === 'lxwm') ? _c('div', [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    class: {
      active: _vm.index === 1
    },
    on: {
      "click": function($event) {
        _vm.index = 1
      }
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.index === 2
    },
    on: {
      "click": function($event) {
        _vm.index = 2
      }
    }
  }, [_vm._v("电子邮箱")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.index === 3
    },
    on: {
      "click": function($event) {
        _vm.index = 3
      }
    }
  }, [_vm._v("在线客服")])]), _vm._v(" "), (_vm.index === 1) ? _c('div', {
    staticClass: "wrapper min-height"
  }, [_c('div', {
    staticClass: "dh1"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.index === 2) ? _c('div', {
    staticClass: "wrapper min-height"
  }, [_c('div', {
    staticClass: "yx1"
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.index === 3) ? _c('div', {
    staticClass: "wrapper min-height"
  }, [_c('div', {
    staticClass: "kf"
  }), _vm._v(" "), _c('div', {
    staticClass: "lkf",
    on: {
      "click": function($event) {
        return _vm.goHref()
      }
    }
  }, [_vm._v("\n          在线客服\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.nr === 'tsjy') ? _c('div', [_c('div', {
    staticClass: "tab"
  }, [_c('a', {
    class: {
      active: _vm.index !== 2
    },
    on: {
      "click": function($event) {
        _vm.index = 1
      }
    }
  }, [_vm._v("投诉电话")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.index === 2
    },
    on: {
      "click": function($event) {
        _vm.index = 2
      }
    }
  }, [_vm._v("投诉邮箱")])]), _vm._v(" "), (_vm.index !== 2) ? _c('div', {
    staticClass: "wrapper min-height"
  }, [_c('div', {
    staticClass: "dh"
  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.index === 2) ? _c('div', {
    staticClass: "wrapper min-height"
  }, [_c('div', {
    staticClass: "yx"
  }), _vm._v(" "), _vm._m(3)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ldh1"
  }, [_c('a', {
    attrs: {
      "href": "tel:4008-889-889"
    }
  }, [_vm._v("4008-889-889")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lyx1"
  }, [_c('a', {
    attrs: {
      "href": "mailto:service@kiiik.com"
    }
  }, [_vm._v("service@kiiik.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ldh"
  }, [_c('a', {
    attrs: {
      "href": "tel:021-23502945"
    }
  }, [_vm._v("021-23502945")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lyx"
  }, [_c('a', {
    attrs: {
      "href": "mailto:qhts@kiiik.com"
    }
  }, [_vm._v("qhts@kiiik.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9746a6b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/lxts/lxts.vue
// module id = 840
// module chunks = 2